import { gql } from '@grandvisionhq/graphql';
import { appointmentFragment } from '../../../fragments/appointment.js';
import { failures } from './fragments/failures.js';

const RESCHEDULE_APPOINTMENT_BY_ID = gql`
  mutation RescheduleAppointmentById($id: ID!, $startTime: String!, $endTime: String!) {
    rescheduleAppointment(id: $id, startTime: $startTime, endTime: $endTime) {
      ... on RescheduleAppointmentResponse {
        appointment {
          ...AppointmentFragment
        }
        failures {
          ...FailureMessage
        }
      }
    }
  }
  ${appointmentFragment}
  ${failures}
`;

export { RESCHEDULE_APPOINTMENT_BY_ID };
//# sourceMappingURL=reschedule-appointment-by-id.js.map
